import { DetailedProject } from '@/domain/project/types';

import { ECommerceItem } from './types';

export function transformDetailedProjectToECommerceItem(
  project: Pick<DetailedProject, 'id' | 'name' | 'ticketMini'> & {
    company: Pick<DetailedProject['company'], 'name'>;
  },
): ECommerceItem {
  return {
    item_id: project.id.toString(),
    item_name: project.name,
    item_price: project.ticketMini,
    item_brand: project.company.name,
  };
}
